export const HEX_PATH_CANONICAL_MASKS = [
  0b000000, // isolated
  0b000001, // end cap
  0b001001, // straight
  0b000011, // bend
  0b000111, // three-way fan
  0b010101, // three-way alternating
  0b011011, // four-way split
  0b011111, // five-way
  0b111111, // full hub
] as const;

export const HEX_PATH_BRUSH_COUNT = HEX_PATH_CANONICAL_MASKS.length;

export function resolveHexPathBrushMask(tileIndex: number): number | null {
  if (!Number.isFinite(tileIndex)) {
    return null;
  }
  const normalized = Math.trunc(tileIndex);
  return HEX_PATH_CANONICAL_MASKS[normalized] ?? null;
}
